import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { showModal } from 'appSrc/redux/actions';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import CategoriesTable from './Table';
import AdminPageHead from '../../Common/PageHead';
import NewCategoryModal from '../../Modals/Category/NewCategoryModal';
import EditCategoryModal from '../../Modals/Category/EditCategoryModal';
import style from './styles/style.module.css';

class AllCategoriesView extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            categories: [],
            newModal: false,
        };
        this.categoryQueryObject = {
            sort: 'id,child_categories.id',
        };
    }
    componentDidMount() {
        this.loadCategories();
    }
    onColumnSort = ( value ) => {
        if( this.categoryQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        if( this.categoryQueryObject.sort == `-${ value }` ) {
            value = 'id,child_categories.id';
        }
        this.categoryQueryObject.page = 1;
        this.categoryQueryObject.sort = value || undefined;
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.categories = [];
            return prevState;
        } );
        this.loadCategories();
    }
    loadCategories = () => {
        return this.props.getCategories( this.categoryQueryObject )
        .then( ( response ) => {
            var categories = response;
            this.setState( {
                fetching: false,
                categories: categories,
            } );
            return categories;
        } );
    }
    openNewModal = () => {
        this.props.showNewCategoryModal( this.onNewModalSubmit );
    }
    onNewModalSubmit = ( newCategory ) => {
        return this.props.createCategory( newCategory )
        .then( () => {
            return this.loadCategories();
        } );
    }

    render() {
        const { fetching, categories } = this.state;

        return (
            <section className={ style.page }>
                <AdminPageHead title='Categories'
                tabs={ [
                    { label: 'View All', to: '/admin/categories' },
                ] }
                buttons={ [
                    { label: '+ Add New Category', onClick: this.openNewModal },
                ] } />
                <div className={ style.body }>
                    <section className={ style.allList }>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <CategoriesTable
                            categories={ categories }
                            onColumnSort={ this.onColumnSort }
                            currentSort={ this.categoryQueryObject.sort }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
                <NewCategoryModal />
                <EditCategoryModal />
            </section>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        getCategories: ( queryObject ) => {
            return dAPI.get( '/admin/categories/metrics', queryObject );
        },
        showNewCategoryModal: ( callback ) => {
            dispatch( showModal( 'newCategoryModal', {
                category: { status: 'draft' },
                callback: callback,
            } ) );
        },
        createCategory: ( newCategory ) => {
            return dAPI.post( '/admin/categories', newCategory );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllCategoriesView );
